<template>
	<article class="stepper-wrap">
		<div class="stepper-wrap--horizontal">

	 		<header class="subscription-head pb-2 mt-0 mb-0">
		 		<!-- <div 
		 			class="back-nav"
		 			v-if="templateData.stepper_parent"
		 			>
		 			<a 
		 				:href="templateData.stepper_parent.link" 
		 				class="caption-uppercase"
		 				><span class="icon-Arrow-Left"></span> {{ templateData.stepper_parent.title }}</a>
	 			</div> -->
		 		<h1 class="page-title title-1">{{ templateData.title }}</h1>
	 		</header>
	  	<!-- <div style="position:relative;z-index:19999"> -->

		 		<!-- <button 
		 			:disabled="slidesPerView <= 1"
		 			@click="changeSlidesPerView(-1)">-</button>
	 			<button 
		 			:disabled="slidesPerView >= component.steps.length"
		 			@click="changeSlidesPerView(+1)">+</button> -->
		 	<!-- </div> -->
	 		<div 
	 			class="steps-timeline"
	 			:class="stepperClass" 
	 			data-aos-delay="500"
	 			>
	 			
	 			<n-carousel 
	 				:slides-per-view="slidesPerView" 
	 				:space-between="0" 
	 				:loop="false" 
	 				:show-arrow="true"
	 				:show-dots="false"
	 				:centered-slides="false"
	 				>
	 				<template #arrow="{ prev, next, currentIndex, total }">
				      <div class="custom-arrow">
				        <button 	
				        	class="slick-next slick-arrow" 
				        	:class="(currentIndex >= total - 1) ? 'slick-disabled': '' " 
				        	aria-label="Next" type="button" 
				        	style="" 
				        	@click="next"
				        	:aria-disabled="currentIndex >= total - 1"
				        	><span class="icon-Chevron-Right-Large"></span></button>

			        	<button 
			        		class="slick-prev slick-arrow"
			        		:class="currentIndex == 0 ? 'slick-disabled': '' " 
			        		aria-label="Previous" 
			        		type="button" 
			        		style="" 
			        		@click="prev"
			        		:aria-disabled="currentIndex == 0"
			        		><span class="icon-Chevron-Left-Large"></span></button>
				      </div>
				    </template>
	 				<template
		 				v-for="(step, step_index) in component.steps"
		 				:key="step.index"
		 			>
			 			<!-- {%  set progress = component.steps_progress[loop.index] %} -->
			 			<StepperStepComponent
			 				:step="step"
			 				:stepIndex="step_index"
			 				:stepsMode="component.post.steps_mode"
							:currentStepIndex="templateData.current_step_index"
			 				>
			 				<template #progressBar>
				 				<div 
									class="progress-bar-wrap"
									v-if="component.post.progress_bar"
									>
							        <div class="progress-bar">
							            <span class="progress" 
							            	:style="`width: ${ step.progress }%`"></span>
							        </div>
							    </div>
							</template>
							<template #stepButtons>
								<StepButtonsComponent
									:step="step"
									:linkTarget="component.links_target"
									:stepsMode="component.post.steps_mode"
									/>
							</template>
			 			</StepperStepComponent>
		 			</template>
		 		</n-carousel>
	 		</div><!-- /steps-timeline -->

		</div>
	</article>

	<div 
		class="fullscreen-modal" 
		v-if="templateData.hide_default_modal">
		<img class="img-blured" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAATSURBVBhXY5ixcN1/dEwnwXX/AVTnVvVRta7fAAAAAElFTkSuQmCC"/>
		<div class="fullscreen-modal-inner elevation-1">
			<a class="close-modal elevation-1" href="#"><span class="icon-clean-4"></span></a>
			<div class="iframe-wrapper">
				<div class="iframe-scroller">
					<iframe id="bryter-module-1" class="bryter-module"
							:data-src="component.iframe_src"
							frameborder="0" width="100%" height="0" ></iframe>
				</div>
			</div>
		</div>
	</div>


	</template>


<script>

import StepButtonsComponent from '@vueapp/components/steppers/StepButtonsComponent.vue'
import StepperStepComponent from '@vueapp/components/steppers/StepperStepComponent.vue'

import { NCarousel } from 'naive-ui'

// import Slick from 'vue-slick';


export default {
	name: 'StepperComponent',
	props: {
		templateData: {
			type: Object,
			default: {

			},
			required: true
		}
	},
	components: {
		StepButtonsComponent,
		StepperStepComponent,
		NCarousel
	},
	data() {
		return {
			slidesPerView: 3,

			responsiveSlidesPerView: [
          {
              breakpoint: 1600,
              settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 1480,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 900,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 800,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 0,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
              }
          }
      ],

			settings: {
				  "dots": true,
				  "focusOnSelect": true,
				  "infinite": true,
				  "speed": 500,
				  "slidesToShow": 3,
				  "slidesToScroll": 3,
				  "touchThreshold": 5
				}
		}
	},
	created() {
  	window.addEventListener("resize", this.onWindowResize);
  	window.dispatchEvent(new Event('resize'));
	},
	destroyed() {
  	window.removeEventListener("resize", this.onWindowResize);
	},
	computed: {
		component() {
			return this.templateData
		},

		stepperClass() {
			return `steps-mode--${ this.templateData.post.steps_mode} ${ this.templateData.post.steps_mode == 'relaxed' ? '' : 'strict-mode' }`
		}
	},
	methods: {
		changeSlidesPerView( slides ) {
			this.slidesPerView = this.slidesPerView + slides
		},
		onWindowResize() {
			let w = window.innerWidth
			
			const responsiveSlidesPerView = [ ...this.responsiveSlidesPerView ],
				l = responsiveSlidesPerView.length
			let cbp = responsiveSlidesPerView[l]
			let bp = this.responsiveSlidesPerView.reduce( (acc, curr) => {
				if ( acc + 1 < l) {
					// console.log(w, curr.breakpoint, responsiveSlidesPerView[acc+1].breakpoint)
					if ( w < curr.breakpoint && w >= responsiveSlidesPerView[acc+1].breakpoint ) {
						// console.log('xxx')
						cbp = curr
					}
				}
				return acc + 1
			}, 0)

			this.slidesPerView = typeof cbp != 'undefined' && cbp ? cbp.settings.slidesToShow : l

			// console.log(w, cbp)

		}
	}
}
</script>

<style scoped>
.carousel-img {
  width: 100%;
  height: 240px;
  object-fit: cover;
}
</style>